/* eslint-disable camelcase, class-methods-use-this */
import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { FormError } from 'wanderu-component-form';
import A from 'wanderu-component-react-router-link';
import SocialButtons from 'wanderu-component-social-buttons';
import TermsAndConditions from 'wanderu-component-terms-and-conditions';
import { localize } from 'wanderu-i18n';

import baseAppConfig from '../../config/baseApp.locales';
import SignUpForm from './SignUpForm/SignUpForm';

import styles from './SignUp.scss';

class SignUp extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        onCreateAccount: PropTypes.func.isRequired,
        onSuccess: PropTypes.func.isRequired,
        email: PropTypes.string,
        error: PropTypes.object,
        loading: PropTypes.bool.isRequired,
        onFacebookClick: PropTypes.func.isRequired,
        onGoogleClick: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        subtitle: PropTypes.node,
        success: PropTypes.bool.isRequired,
        suggestLogIn: PropTypes.bool.isRequired,
        title: PropTypes.node,
    };

    static defaultProps = {
        onCreateAccount() {},
        onSuccess() {},
        className: '',
        loading: false,
        reset() {},
        success: false,
        suggestLogIn: true,
        subtitle: null,
        title: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            email: this.props.email,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.email !== this.props.email) {
            this.setState(() => ({
                email: nextProps.email,
            }));
        }

        if (nextProps.success !== this.props.success && nextProps.success) {
            this.props.onSuccess();
        }
    }

    _onFormChange = (formData) => {
        this.setState(() => ({
            email: formData.email,
        }));
    };

    _onFormFocus = () => {
        this.props.reset();
    }

    _renderUnknownError() {
        return <FormError unknown />;
    }

    _renderValidationError() {
        const { t } = this.props;

        return (
            <FormError>
                {t('invalid-form-error')}
            </FormError>
        );
    }

    _renderUserAlreadyExistsError() {
        const { t } = this.props;
        const { email } = this.state;

        return (
            <FormError>
                {t('account-exists', {
                    signInLink: (
                        <A
                            className={styles.logInError}
                            href="/account/login"
                            key="signInLink"
                            queries={{ email }}
                        >
                            {t('log-in')}
                        </A>
                    ),
                })}
            </FormError>
        );
    }

    renderGeneralLoginError() {
        const { t } = this.props;
        return (
            <FormError>
                {t('general-login-error', {
                    helpLink: (
                        <A
                            className={styles.logInError}
                            href="https://help.wanderu.com"
                            key="helpLink"
                        >
                            https://help.wanderu.com
                        </A>
                    ),
                })}
            </FormError>
        );
    }

    render() {
        const {
            className,
            disabled,
            error,
            loading,
            onCreateAccount,
            onFacebookClick,
            onGoogleClick,
            success,
            subtitle,
            suggestLogIn,
            title,
            t,
        } = this.props;
        const { email } = this.state;

        let userAlreadyExistsError = false;
        let validationError = false;
        let generalLoginError = false;
        let unknownError = false;
        if (error) {
            if (error.name === 'UserAlreadyExistsError') {
                userAlreadyExistsError = true;
            } else if (error.name === 'CreateAccountValidationError') {
                validationError = true;
            } else if (error.name === 'GeneralLoginError') {
                generalLoginError = true;
            }
            unknownError = true;
        }

        const hasError = unknownError || validationError || userAlreadyExistsError || generalLoginError;

        return (
            <>
                <div className={classNames(styles.container, className)}>
                    {title || (
                        <div className={styles.title}>
                            {t('signup-value-prop')}
                        </div>
                    )}
                    {subtitle}
                    <SocialButtons
                        onFacebookClick={onFacebookClick}
                        onGoogleClick={onGoogleClick}
                    />
                    <div className={styles.orContainer}>
                        <span className={styles.orBar} />
                        <span className={styles.or}>
                            {t('or')}
                        </span>
                        <span className={styles.orBar} />
                    </div>
                    {unknownError && this._renderUnknownError()}
                    {validationError && this._renderValidationError()}
                    {userAlreadyExistsError && this._renderUserAlreadyExistsError()}
                    {generalLoginError && this.renderGeneralLoginError()}
                    <SignUpForm
                        defaultValues={{ email }}
                        disabled={disabled}
                        hasError={hasError}
                        loading={loading}
                        onChange={this._onFormChange}
                        onFocus={this._onFormFocus}
                        onSubmit={onCreateAccount}
                        success={success}
                    />
                    {suggestLogIn && (
                        <div className={styles.signUp}>
                            {t('have-account')}
                                    &nbsp;
                            <A
                                href="/account/login"
                                queries={{ email }}
                            >
                                {t('log-in')}
                            </A>
                        </div>
                    )}
                    <div className={styles.hr} />
                    <div className={styles.termsAndConditions}>
                        {t('terms-and-conditions-agreement', {
                            termsAndConditions: (
                                <TermsAndConditions
                                    href="/privacy-policy"
                                    key="privacy-policy"
                                    linkText={t('privacy-policy')}
                                />
                            ),
                        })}
                    </div>
                </div>
            </>
        );
    }
}

export { SignUp };
export default localize(SignUp, ['t'], baseAppConfig.namespace);
